import React from 'react';
import { FormattedMessage } from 'react-intl';
import dragula from 'react-dragula';

import randomstring from 'uuid/v4';

import BarChart from '@material-ui/icons/BarChart';
import BubbleChart from '@material-ui/icons/BubbleChart';
import History from '@material-ui/icons/List';

import { AddIcon, TrashIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

let moves = true;
let scrollable = true;
let listener = function(e) {
    if (!scrollable) {
        e.preventDefault();
    }
};

class EditCurrenTab extends React.Component {

    constructor(props) {
        super(props);
        moves = props.edit;
    }

    UNSAFE_componentWillMount() {
        document.addEventListener('touchmove', listener, { passive: false });
        this.drake = dragula([document.querySelector('.container')], {
            moves: function(el, container, handle) {
                return handle.classList.contains('draggable');
            },
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });

        this.drake = dragula([].slice.apply(document.querySelectorAll('.bloc')), {
            direction: 'horizontal',
            moves: function() {
                return moves;
            },
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        moves = !nextProps.alpha;
        this.setState({ items: nextProps.items });
    }

    componentDidUpdate() {
        this.drake.containers = [].slice.apply(document.querySelectorAll('.bloc'));
    }

    drop = (el, target, source, sibling) => {
        scrollable = true;
        this.drake.cancel(true);

        const arr = [...this.props.tab.widgets];
        const from = el.id;
        const to = sibling === null ? arr.length : sibling.id;

        this.props.onReorder(from, to);
    };

    render() {
        const { tab } = this.props;
        const { widgets } = tab;
        const render = widgets.map((w, i) => {w.id = i; return w; });
        const IconButton = ({icon, text}) => {
            return (<div className="box bg_bluish c_white margin_top_12 padding_borders">
                            <div className="flex_auto_row barlow_regular_small margin_top_12 center">
                                {icon}
                            </div>
                            <div className="flex_auto_row barlow_regular_small margin_top_12">
                                <FormattedMessage id={text} />
                            </div>
                        </div>);
        }

        const AddWidget = () => {
            return (
                    <div className="card padding_4 addcard">
                        <div className="boxBorder flex_full_row heightWidget center hand bg_white">
                            <AddIcon 
                                color="primary"  
                                fontSize={"large"}
                                onClick={() => this.props.onAdd(true)}
                                />
                        </div>
                    </div>
                    );
        }

        const Widget = ({widget, index}) => {
            return (
                <div id={index} className="flex_full_row heightWidget padding_4">
                    <div  className="boxBorder heightWidget flex_full_column bg_white  ">
                        <div 
                            className="flex_full_column center hand" 
                            onClick={() => this.props.onAdd(widget)}>
                            <span className="flex_auto_row barlowcondensed_medium c_cornflower_blue uppercase">
                                {widget.nombre}
                            </span>
                            {widget.tipo === 1 &&
                                <IconButton 
                                    icon={<BubbleChart className="hand" />}
                                    text={'widget_type_chart_bubble'}
                                    />
                            }
                            {widget.tipo === 2 &&
                                <IconButton 
                                    icon={<BarChart className="hand" />}
                                    text={'widget_type_chart_bar'}
                                    />
                            }
                            {widget.tipo === 3 &&
                                <IconButton 
                                    icon={<History className="hand" />}
                                    text={'widget_type_chart_historic'}
                                    />
                            }
                        </div>
                        <div className="flex_auto_row margin_top_12 margin_bottom_12 margin_left_12">
                            <TrashIcon color="secondary" className="hand" onClick={() => this.props.onDelete(widget)} />
                        </div>
                    </div>
                </div>
            );
        }

        return (
                <div className="cards height100 width100">
                    {render && render.length > 0 &&
                        render.map((item, index) => {
                            return (<div key={randomstring()} className={'bloc card'}>
                                        <Widget widget={item} index={index} />
                                    </div>);
                                })
                    }
                    {(!render || render.length < 6) &&
                        <AddWidget />
                    }
                </div>
            );
    }
}


export default EditCurrenTab;


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/EditCurrentTab.js